import AuthErrorLayout from "./AuthErrorLayout";

export default AuthErrorLayout;
